import {SendStyleNavbar, NavbarKey} from './navbar-new';
import {useNavbarViewportScale} from './use-navbar-viewport-scale';

export type {NavbarKey};

interface SiteHeaderProps {
  active?: NavbarKey;
}

/**
 * Fixed-position site nav shell. Use on all public/marketing pages so the
 * header (including profile avatar + NavbarAuthMenuNew) stays consistent.
 */
export function SiteHeader({active}: SiteHeaderProps) {
  const {scale} = useNavbarViewportScale();

  return (
    <header className="relative z-30 mx-auto w-full max-w-[1895px] flex-shrink-0 overflow-visible px-[6px] pt-[12px] lg:px-[12px] lg:pt-[17px]">
      <SendStyleNavbar
        active={active}
        className="mx-auto w-full max-w-[1565px]"
        viewportScale={scale}
      />
    </header>
  );
}
